import { type FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { LoadingSpinner } from "widgets";

import styleLayout from "../core/styles/PageLayout.module.scss";

import { ContentPlaceholder } from "../core/ContentPlaceholder.js";
import { GenomeView, type IGenomeViewOwnProps } from "./GenomeView.js";
import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { loadView } from "@/redux/modules/saved-view.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { VIEW } from "@/settings/settings.js";

interface GenericEntityGenomeViewProps {
  genomeViewProps: IGenomeViewOwnProps;
  placeholderText?: string;
  loadEntityData?: () => void;
}

const GenericEntityGenomeView: FC<GenericEntityGenomeViewProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();
  const viewId = useURLViewID();

  useEffect(() => {
    dispatch(loadView(viewId)).then((view) => {
      if (!view || view?.viewType !== VIEW.GENOME_VIEW.type) {
        //TODO Do we need it as the parent components seem to already load it? (Check GenomeGenomeView for instance)
        props.loadEntityData?.();
      }
    });
  }, []);

  if (props.placeholderText) {
    return (
      <div className={styleLayout.page}>
        <ContentPlaceholder text={props.placeholderText} />
      </div>
    );
  } else if (props.genomeViewProps) {
    return <GenomeView {...props.genomeViewProps} />;
  } else {
    return (
      <div className={styleLayout.page}>
        <LoadingSpinner inCenter />
      </div>
    );
  }
};

export default GenericEntityGenomeView;
